import React from 'react';
import { WelcomeContainer, GreetingLine, SubheadingLine, WelcomeConent } from './styled';

export interface WelcomeMessageProps {
  userName?: string;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = (props: WelcomeMessageProps) => {
  const firstName = props?.userName || 'there';
  return (
    <WelcomeContainer>
      <GreetingLine>{`Hey ${firstName},`}</GreetingLine>
      <SubheadingLine>how can I help you?</SubheadingLine>
      <WelcomeConent>I’m your companion for amazing trips, inspiring stays, and hidden gems worldwide.</WelcomeConent>
    </WelcomeContainer>
  );
};

export default WelcomeMessage;
